import PropTypes from "prop-types";
import { BREADCRUMB_WRAPPER_ID } from "../../../../constants/reactPortal";
import ReactPortal from "../../../ReactPortal/ReactPortal";
import Breadcrumb from "../Breadcrumb";

const PortalBreadcrumb = (props) => {
  const { paths, className } = props;

  return (
    <ReactPortal wrapperId={BREADCRUMB_WRAPPER_ID}>
      <Breadcrumb paths={paths} classNames={className} />
    </ReactPortal>
  );
};

export default PortalBreadcrumb;

PortalBreadcrumb.propTypes = {
  classNames: PropTypes.string,
  paths: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      label: PropTypes.string.isRequired,
    })
  ),
};
